import { apiService } from './api'

class BlockService {
  async getBlocks(params?: any) {
    const response = await apiService.api.get('/admin/blocks', { params })
    return response.data
  }

  async getBlockStats() {
    const response = await apiService.api.get('/admin/blocks/stats')
    return response.data
  }

  async deleteBlock(id: number) {
    const response = await apiService.api.delete(`/admin/blocks/${id}`)
    return response.data
  }
}

export const blockService = new BlockService()
export default blockService
